import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { timeSince, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../../common/app_constant";
import { actionGetAllNotification, actionLatestNotification, actionMarkAllNotificationRead, actionNotificationDelete, resetGetAllNotification, resetNotificationDelete } from "../store";
import Swal from 'sweetalert2';
import Loader from "../../../../../component/page_loader";
import InfromationCard from "../../../../../component/information_card";
import Blog from "../../../../../component/blog";


const Notifications = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()


    const { getAllNotification, notificationDelete } = useSelector((state) => ({
        ...state.NotificationStore
    }))

    const [allNotification, setAllNotification] = useState([])
    const [selectedNotifications, setSelectedNotifications] = useState([])

    const [isLoader, setIsLoader] = useState(true)
    const [filterArr, setFilterArr] = useState([])
    const [searchNotification, setSearchNotification] = useState('')


    useEffect(() => {
        dispatch(actionMarkAllNotificationRead())
        dispatch(actionLatestNotification())
        dispatch(actionGetAllNotification())

    }, [])


    useEffect(() => {
        if (getAllNotification !== null) {
            dispatch(resetGetAllNotification())
            if (getAllNotification.result === true) {
                setIsLoader(false)
                setFilterArr(getAllNotification.response)
                setAllNotification(getAllNotification.response)
            } else {
                setIsLoader(false)
                switch (getAllNotification.status_code) {
                    case 401:
                        toast.error(getAllNotification.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login");
                        break;
                    default:
                }
            }
        }
    }, [getAllNotification])

    useEffect(() => {
        if (notificationDelete !== null) {
            dispatch(resetNotificationDelete())
            if (notificationDelete.result === true) {
                toast.success(notificationDelete.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                dispatch(actionGetAllNotification())
            } else {
                switch (notificationDelete.status_code) {
                    case 401:
                        toast.error(notificationDelete.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login");
                        break;
                    default:
                }
            }
        }
    }, [notificationDelete])


    const renderAllNotification = () => {

        var allNotificationArr = []

        allNotification != null && allNotification.length > 0 ?
            allNotification.map((item, index) => {
                allNotificationArr.push(
                    <div className="card profile-section mb-3">
                        <div className="card-body d-flex">
                            <div>
                                <input type="checkbox" id={item.id} name={`notification-${item.id}`}
                                    checked={selectedNotifications.includes(item.id)}
                                    onChange={() => {
                                        var arrSelectedNotificationsId = Object.assign([], selectedNotifications)
                                        if (arrSelectedNotificationsId.includes(item.id)) {
                                            var index = arrSelectedNotificationsId.findIndex((notificationId, indexId) => notificationId === item.id)
                                            if (index > -1) {
                                                arrSelectedNotificationsId.splice(index, 1)
                                            }
                                        } else {
                                            arrSelectedNotificationsId.push(item.id)
                                        }
                                        setSelectedNotifications(arrSelectedNotificationsId)
                                    }}
                                />
                            </div>
                            <div className="ms-3">
                                <p className="mb-1">
                                    <b>{item.title}</b>
                                </p>
                                <p className="mb-1 text-secondary">
                                    {item.notification}
                                </p>
                                <p className="small text-primary mb-0">{timeSince(item.created_at)}</p>
                            </div>
                            <div className="ms-auto">
                                <button className="btn" onClick={() => {
                                    Swal.fire({
                                        title: 'Are you sure?',
                                        text: "Are you sure you want to delete this Notification?",
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes, delete it!',
                                        customClass: {
                                            confirmButton: 'btn btn-primary',
                                            cancelButton: 'btn btn-danger margin-left'
                                        },
                                        buttonsStyling: false

                                    }).then(function (result) {
                                        if (result.value) {
                                            dispatch(actionNotificationDelete({ id: item.id }))
                                        }
                                    })

                                }}>
                                    <i className="fa fa-trash fs-6" />
                                </button>
                            </div>
                        </div>
                    </div>
                )
            })

            :
            allNotificationArr.push(
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <h5>No Notifications To Display</h5>
                </div>
            )
        return allNotificationArr
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a onClick={() => {
                                    navigate('/dashboard')
                                }}>Dashboard</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Notifications
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between">
                                        <div className="">
                                            <a className="btn btn-light btn-sm mx-2 fw-bold">
                                                Notifications ({allNotification.length})
                                            </a>
                                        </div>
                                        {
                                            allNotification != null && allNotification.length > 0 ?
                                                <div className="">
                                                    <button className="btn btn-primary"
                                                        disabled={selectedNotifications.length === 0 ? true : false}
                                                        onClick={() => {
                                                            Swal.fire({
                                                                title: 'Are you sure?',
                                                                text: "Are you sure you want to delete this Notifications?",
                                                                icon: 'warning',
                                                                showCancelButton: true,
                                                                confirmButtonText: 'Yes, delete it!',
                                                                customClass: {
                                                                    confirmButton: 'btn btn-primary',
                                                                    cancelButton: 'btn btn-danger margin-left'
                                                                },
                                                                buttonsStyling: false

                                                            }).then(function (result) {
                                                                if (result.value) {
                                                                    dispatch(actionNotificationDelete({ id: selectedNotifications }))
                                                                }
                                                            })

                                                        }}
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                    {/* <button className="btn btn-primary" style={{ marginLeft: 4 }}>Cancel</button> */}
                                                </div>
                                                :
                                                <></>
                                        }

                                    </div>
                                </div>
                                <div className="col-12">

                                    <div>
                                        <div className="card-body d-md-flex">
                                            <div className="my-auto d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={(event) => {
                                                        if (allNotification != null && allNotification.length > 0) {
                                                            if (event.target.checked) {
                                                                var arrSelectedNotificationId = []
                                                                if (allNotification != null && allNotification.length > 0) {
                                                                    allNotification.forEach((notification, index) => {
                                                                        arrSelectedNotificationId.push(notification.id)
                                                                    })
                                                                }
                                                                setSelectedNotifications(arrSelectedNotificationId)
                                                            } else {
                                                                setSelectedNotifications([])
                                                            }
                                                        }
                                                    }}
                                                />
                                                <p className="ms-3 my-auto">
                                                    <b>Select All</b>
                                                </p>
                                            </div>
                                            <div className="ms-auto my-auto mt-2 mt-md-0">
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder={'Search Notification'}
                                                    value={searchNotification}
                                                    onChange={(event) => {
                                                        setSearchNotification(event.target.value)
                                                        var arrFilterNotification = Object.assign([], filterArr);
                                                        if (event.target.value.length > 0) {
                                                            setSearchNotification(event.target.value)
                                                            var arrFilterNotification = arrFilterNotification.filter(
                                                                (item) =>
                                                                    item.title.toLowerCase().includes(event.target.value.toLowerCase())
                                                            );
                                                            setAllNotification(arrFilterNotification)
                                                        } else {
                                                            setSearchNotification(event.target.value)
                                                            setAllNotification(filterArr)
                                                        }
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    {renderAllNotification()}
                                </div>
                            </div>
                    }
                </div>
                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />
                    <Blog />
                </div>
            </div>

        </>
    )

}

export default Notifications;